// const apiName = "https://exams.aspireitacademy.com/"; // Real world Api
const apiName = "https://examapi.cydeztechnologies.com/" // Testing Api
export default apiName;